import { EventRegistrationFormFieldType } from '../generated/api/dsv-public/model';
import { ElementType } from 'react';
import { SingleLineField } from './SingleLineField';
import { MultiLineField } from './MultiLineField';
import { DateField } from './DateField';
import { SingleSelectField } from './SingleSelectField';
import { RadioField } from './RadioField';
import { MultiSelectField } from './MultiSelectField';
import { CheckboxField } from './CheckboxField';
import { InfoField } from './InfoField';
import { SpaceField } from './SpaceField';
import { TermsAndConditionsField } from './TermsAndConditionsField';
import { PhoneNumberField } from './PhoneNumberField';

export type FieldComponents = {
  [fieldType in EventRegistrationFormFieldType]: ElementType;
};

export const fieldComponents: FieldComponents = {
  SINGLE_LINE: SingleLineField,
  MULTI_LINE: MultiLineField,
  DATE: DateField,
  SINGLE_SELECT: SingleSelectField,
  MULTI_SELECT: MultiSelectField,
  RADIO: RadioField,
  CHECKBOX: CheckboxField,
  TERMS_AND_CONDITIONS: TermsAndConditionsField,
  INFO: InfoField,
  SPACE: SpaceField,
  PHONE_NUMBER: PhoneNumberField,
  UPLOAD: MultiLineField, // TODO change to correct component
};

export type FieldType = {
  fieldKey: string;
  name: string;
  required: boolean;
  description?: string;
  defaultValue: any;
  onChangeFieldValue: (field: string, value: any) => void;
};
